import SideMenu from '@/containers/side-menu/SideMenu.vue';
import FinancialAccountHistoryTable from '@/pages/financial-account-history-table/FinancialAccountHistory.vue';

export default {
  path: '/financial-account-history-table',
  name: 'FinancialAccountHistoryTable',
  components: {
    mainContent: FinancialAccountHistoryTable,
    mainMenu: SideMenu,
  },
  meta: {
    role: {
      sectorId: 'financial-account-history',
    },
    breadcrumb: {
      title: 'Contas',
      paths: [{ title: 'Histórico' }],
    },
  },
};
